import React from "react";
import PropTypes from "prop-types";

const UsageStat = ({ type, values }) => {
  let title;
  let description;
  switch (type) {
    case "simple-shreds":
      title = `${values[0]}`;
      description = "Simple Shreds Generated";
      break;
    case "sign-ins":
      title = `${values[0]}`;
      description = "Sign-ins over last 30 days";
      break;
    case "pdf-reports":
      title = `${values[0]}`;
      description = "Number of PDF Reports generated";
      break;
    case "exports":
    default:
      title = `${values[0]}`;
      description = "Number of exports to Excel or CSV";
      break;
  }
  return (
    <div className="usage_stat" data-testid="usage-stat">
      <span className="usage_stat__title">{title}</span>
      <span className="usage_stat__description">{description}</span>
    </div>
  );
};

export default UsageStat;

UsageStat.propTypes = {
  type: PropTypes.string.isRequired,
  values: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
